document.addEventListener('DOMContentLoaded', () => {
	const videoContainer = document.getElementById('videoContainer')

	if (videoContainer) {
		const playButton = document.getElementById('playButton')
		const poster = document.getElementById('poster')
		const video = document.getElementById('video')

		video.addEventListener('ended', () => {
			poster.style.display = 'block'
			playButton.style.opacity = 1
		})

		videoContainer.addEventListener('click', () => {
			if (video.paused) {
				video.play()
				poster.style.display = 'none'
				playButton.style.opacity = 0
			} else {
				video.pause()
				poster.style.display = 'block'
				playButton.style.opacity = 1
			}
		})
	}
})
